import { jsx as _jsx } from "react/jsx-runtime";
import ProjectMetadataModal from 'components/ProjectMetadataModal';
import { useEditorContext } from '../../contexts/projectSignal';
const MetadataModal = ({ onClose, enqueueProjectUpdate, onMetadataChange }) => {
    const { projectSignal } = useEditorContext();
    return (_jsx(ProjectMetadataModal, { visible: true, description: projectSignal.peek().description, projectId: projectSignal.peek().id, onCancel: onClose, onMetadataChange: onMetadataChange, enqueueProjectUpdate: enqueueProjectUpdate }));
};
export default MetadataModal;
